import videojs from 'video.js'

export let isPlayerDebugMode = false

export function setPlayerDebugMode(playerDebugMode: boolean) {
  isPlayerDebugMode = playerDebugMode
  videojs.log.level(playerDebugMode ? 'all' : 'info')
}
